import * as THREE from 'three';
import {genOrthographicCamera} from '@/threejsEnv/camera.js';
import {GlobalManager} from '@/core/GlobalManager.js';
import SceneManager from '@/core/SceneManager.js';

// 参数选择场景
export default class ParamSelectScene {

    enabled = false;
    
    camera = null;
    scene = null;
    renderer = null;

    constructor() {
        this.initScene();
        this.initCamera();
        this.addMesh();
        this.addEvent();
    }

    initScene() {
        var intance = SceneManager.getInstance()
        this.scene = intance.createScene("ParamSelectScene",{arrow:true});
    }

    initCamera() {
        this.camera = genOrthographicCamera();
        this.renderer = GlobalManager.get("renderer");
    }

    addMesh() {
        const material = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: false });
        const geometry = new THREE.BoxGeometry();
        var cube = new THREE.Mesh(geometry, material);
        this.scene.add(cube);
    }

    // 添加鼠标点击事件
    addEvent() {
        this.raycaster = new THREE.Raycaster();
        this.mouse = new THREE.Vector2();
        //这里不要改写成()=>{},因为this的作用域不同，导致实例销毁时无法移除匿名函数。
        window.addEventListener('click', this.onMouseClick);
    }

    onMouseClick(event){
        console.log(event);
    }
    
    animate(){
        if(!this.enabled){
            return ;
        }
        this.renderer.render(this.scene, this.camera);
    }
}
